<ptl-v3-content-card [item]="cardItem()" [action]="action()" (cardClicked)="onCardOpen()" (actionClicked)="onCardOpen()">
</ptl-v3-content-card>
